import React from 'react';
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  CardMedia,
  IconButton,
  Divider
} from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';
import GavelIcon from '@mui/icons-material/Gavel';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import WorkIcon from '@mui/icons-material/Work';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import SecurityIcon from '@mui/icons-material/Security';

const Services = () => {
  const services = [
    {
      title: "Derecho Corporativo",
      description: "Asesoramiento integral en fusiones y adquisiciones, constitución de sociedades, contratos mercantiles y gobierno corporativo.",
      icon: <BusinessIcon sx={{ fontSize: 40 }} />,
      image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=1000"
    },
    {
      title: "Derecho Laboral",
      description: "Especialistas en relaciones laborales, negociación colectiva, reestructuraciones y auditorías laborales.",
      icon: <WorkIcon sx={{ fontSize: 40 }} />,
      image: "https://images.unsplash.com/photo-1521791136064-7986c2920216?q=80&w=1000"
    },
    {
      title: "Litigación",
      description: "Representación legal en tribunales, arbitraje y mediación en conflictos comerciales y civiles.",
      icon: <GavelIcon sx={{ fontSize: 40 }} />,
      image: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?q=80&w=1000"
    },
    {
      title: "Derecho Fiscal",
      description: "Planificación fiscal, cumplimiento normativo y representación ante autoridades tributarias.",
      icon: <AttachMoneyIcon sx={{ fontSize: 40 }} />,
      image: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?q=80&w=1000"
    },
    {
      title: "Derecho Administrativo",
      description: "Asesoramiento en contratación pública, licencias y permisos administrativos.",
      icon: <AccountBalanceIcon sx={{ fontSize: 40 }} />,
      image: "https://images.unsplash.com/photo-1436450412740-6b988f486c6b?q=80&w=1000"
    },
    {
      title: "Compliance",
      description: "Implementación de programas de cumplimiento normativo y prevención de riesgos legales.",
      icon: <SecurityIcon sx={{ fontSize: 40 }} />,
      image: "https://images.unsplash.com/photo-1507537297725-24a1c029d3ca?q=80&w=1000"
    }
  ];

  return (
    <Box sx={{ pt: 8 }}>
      <Box sx={{ bgcolor: 'primary.main', color: 'white', py: 8 }}>
        <Container>
          <Typography variant="h2" component="h1" gutterBottom>
            Nuestros Servicios
          </Typography>
          <Typography variant="h5">
            Soluciones legales integrales para su negocio
          </Typography>
        </Container>
      </Box>

      <Container sx={{ py: 8 }}>
        <Grid container spacing={4}>
          {services.map((service, index) => (
            <Grid item key={index} xs={12} sm={6} md={4}>
              <Card 
                sx={{ 
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  transition: 'transform 0.2s',
                  '&:hover': {
                    transform: 'translateY(-8px)'
                  }
                }}
              >
                <CardMedia
                  component="img"
                  height="200"
                  image={service.image}
                  alt={service.title}
                />
                <CardContent sx={{ flexGrow: 1 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <IconButton 
                      color="primary"
                      sx={{ mr: 1, backgroundColor: 'primary.light', '&:hover': { backgroundColor: 'primary.main' } }}
                    >
                      {service.icon}
                    </IconButton>
                    <Typography variant="h5" component="h2">
                      {service.title}
                    </Typography>
                  </Box>
                  <Divider sx={{ my: 2 }} />
                  <Typography variant="body1" color="text.secondary">
                    {service.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Services;